import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PreferableRouteResponse} from './preferable-route/model/preferable-route.response';
import {PreferableRouteEntry} from './preferable-route/model/preferable-route.entry';
import {PreferableRouteDetailsResponse} from './preferable-route/model/preferable-route-details.response';

@Injectable()
export class RouteService {

  constructor(private http: HttpClient) {
  }

  public calculateRoute(request: any, zoom: number): Observable<PreferableRouteResponse> {
    return this.http.post<PreferableRouteResponse>(`/api/routing/route?mapZoom=${zoom}`, request);
  }

  public fetchPreferableRoutes(): Observable<PreferableRouteEntry[]> {
    return this.http.get<PreferableRouteEntry[]>('/api/preferable-route')
  }

  public savePreferableRoute(request: any): Observable<PreferableRouteEntry> {
    return this.http.post<PreferableRouteEntry>('/api/preferable-route', request);
  }

  public updatePreferableRoute(request: any): Observable<void> {
    return this.http.put<void>('/api/preferable-route', request)
  }

  public loadDetails(id: number): Observable<PreferableRouteDetailsResponse> {
    return this.http.get<PreferableRouteDetailsResponse>(`/api/preferable-route/details?id=${id}`)
  }

  public loadMultiDetails(ids: number[]): Observable<PreferableRouteDetailsResponse[]> {
    return this.http.get<PreferableRouteDetailsResponse[]>(`/api/preferable-route/multi-details?ids=${ids}`)
  }

  public deletePreferableRoute(id: number): Observable<void> {
    return this.http.delete<void>(`/api/preferable-route?id=${id}`)
  }

}
